import Vue from 'vue';
import Router from 'vue-router';
import store from './store/store';
import sharedRoutes from 'myra-ui-common/routes/shared';
import Authentication from './views/authentication/Authentication';
import hasOwnProperty from 'myra-ui-common/utils/hasOwnProperty';

Vue.use(Router);

const router = new Router({
    mode   : 'history',
    base   : process.env.BASE_URL,
    routes : [
        {
            path     : '/(home)?',
            name     : 'home',
            redirect : (to) => {
                if (store.getters.isLoggedIn) {
                    window.location.href = (to.query.redirect && store.getters.isKnownHost(to.query.redirect)) ? to.query.redirect : store.getters.getHost('users');
                }
            }
        },
        {
            path     : '/newLogin',
            name     : 'newLogin',
            redirect : () => {
                const newDashboardHost = store.getters.getHost('newDashboard');
                return window.location.href = `${newDashboardHost}/login`;
            }
        },
        {
            path      : '/login',
            name      : 'login',
            component : Authentication,
            meta      : {
                public : true,
                title  : 'route.meta.login.title'
            }
        },
        {
            path      : '/tfa',
            name      : 'tfa',
            component : Authentication,
            meta      : {
                public : true,
                title  : 'route.meta.login.title'
            }
        },
        {
            path      : '/tfaActivation',
            name      : 'tfaActivation',
            component : Authentication,
            meta      : {
                public : true,
                title  : 'route.meta.login.title'
            }
        },
        {
            path      : '/forgot-password',
            name      : 'forgotPassword',
            component : Authentication,
            meta      : {
                public : true,
                title  : 'route.meta.forgotPassword.title'
            }
        },
        {
            path      : '/new-password/:token',
            name      : 'newPassword',
            component : Authentication,
            meta      : {
                public : true,
                title  : 'route.meta.newPassword.title'
            }
        },
        {
            path     : '/user/:userId',
            name     : 'user',
            redirect : (to) => {
                window.location.href =
                    store.getters.getHost('users') + to.fullPath;
            }
        },
        ...sharedRoutes
    ]
});

router.beforeEach((to, from, next) => {
    // if it's public: go there
    if (to.matched.some((record) => record.meta.public)) {
        next();
        return;
    }

    let redirectRoute = hasOwnProperty(from.query, 'redirect')
        ? from.query.redirect
        : null;

    // if it's not a public route and the user is not logged in, go to the login/tfa page
    if (!store.getters.isLoggedIn) {
        const route = {
            name  : store.getters.isAwaiting2FA ? 'tfa' : (store.getters.isAwaitingActivation ? 'tfaActivation' : 'login'),
            query : {}
        };

        if (redirectRoute !== null) {
            route.query.redirect = redirectRoute;
        }

        next(route);
        return;
    }

    redirectRoute = atob(redirectRoute);

    // if there's a redirect go there
    if (redirectRoute !== null && store.getters.isKnownHost(redirectRoute)) {
        window.location.href = redirectRoute;
        return;
    }

    // @todo : re-enable on boarding form
    if (store.getters.showOnBoardingForm) {
        //window.location.href = store.getters.getHost("users") + "/on-boarding-form";
        // return;
    }

    // continue normally
    next();
});

export default router;
